import { FC } from 'react';

interface SkipForwardIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const SkipForwardIcon: FC<SkipForwardIconProps> = ({ width = 16, height = 16, color = 'white' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
      <g id="skip-forward">
        <path
          id="Icon"
          d="M12.6666 3.33337V12.6667M5.06626 11.947L8.95876 8.83297C9.31466 8.54825 9.49261 8.40589 9.55703 8.23391C9.61352 8.08311 9.61352 7.91697 9.55703 7.76618C9.49261 7.59419 9.31466 7.45183 8.95876 7.16711L5.06626 4.05311C4.51148 3.60929 4.23409 3.38738 4.00064 3.38712C3.79761 3.38691 3.60555 3.47921 3.47889 3.63789C3.33325 3.82034 3.33325 4.17557 3.33325 4.88604V11.114C3.33325 11.8245 3.33325 12.1797 3.47889 12.3622C3.60555 12.5209 3.79761 12.6132 4.00064 12.613C4.23409 12.6127 4.51148 12.3908 5.06626 11.947Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default SkipForwardIcon;
